import { FCRAWorkerCheckRecord } from '@/types/turn-api';
import { TurnTargetsEnum } from '@/types/turn-enums';

export const TYPE_TO_TARGET: Record<FCRAWorkerCheckRecord.Type, TurnTargetsEnum> = {
  COUNTY: TurnTargetsEnum.UpdateWorkerCriminalRecord,
  FEDERAL: TurnTargetsEnum.UpdateWorkerFederalRecord,
  MVR_ACCIDENT: TurnTargetsEnum.UpdateWorkerMvrAccident,
  MVR_ACTION: TurnTargetsEnum.UpdateWorkerMvrAction,
  MVR_VIOLATION: TurnTargetsEnum.UpdateWorkerMvrViolation,
  NATIONAL: TurnTargetsEnum.UpdateWorkerNationalRecord,
  SEX_OFFENDER: TurnTargetsEnum.UpdateWorkerSexOffenderRecord,
  WATCHLIST: TurnTargetsEnum.UpdateWorkerWatchlistRecord,
};
